<div class="header" >
  <div class="content" [ngsRevealSet]="{ reset:false, scale:1, distance: '20px'}" [ngsInterval]="50" [ngsSelector]="'.pageTitle'">
    <div class="contentInner">
      <div class="pageTitle">
        <h1 class="headline">Hardware</h1>
      </div>
    </div>
  </div>
</div>
<div class="content">
  <div class="contentInner">
    <h2 class="sectionHeader" id="led-light-enclosure">Tablet Enclosures</h2>
    <p>Would you like to use Apple devices for your meeting rooms, but still have all the advantages of a dedicated room display device?  The <b>W124 Tablet Enclosures by PoE Texas</b> offer an easy way to wall mount your iPad to a wall or mullion.  Each mount offers:</p>
    <ul>
      <li>Powered via USB-C with Power Over Ethernet Accessories</li>
      <li>Solid metal construction</li>
      <li>Concealed power cable</li>
      <li>Screw holes for wall mounting</li>
      <li>LED status light, colored by your meeting room's status</li>
      <li>Optionally available with a mullion mount</li>
      <li>Supports iPad 10, 11-inch iPad Air, and 11-inch iPad Pro</li>
    </ul>
    <img class="illustration" src="/assets/images/ipad-wall-mount.png">
    <p>The tablet enclosures are available in 4 varieties - in black or silver, and with or without the mullion mount.
      For more information, and to purchase, visit PoE Texas's website.</p>
    <a class="button" href="https://shop.poetexas.com/collections/dash" target="_blank">Visit PoE Texas</a>
  </div>
</div>
